var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-plyr',{staticClass:"cs-video"},[_c('div',{attrs:{"data-plyr-provider":_vm.video.provider,"data-plyr-embed-id":_vm.video.videoid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }